
const headers = [
  {
    label: 'เลขร้องทุกข์',
    field: 'complaintCode',
  },
  {
    label: 'ผู้ประกอบการ / ชื่อผู้ร้องทุกข์ / ผู้มอบอำนาจ',
    field: 'companyName',
  },
  {
    label: 'วันที่ยื่นเรื่อง - วันที่ต้องดำเนินการ / สถานะดำเนินการ / ช่องทางร้องทุกข์',
    field: 'status',
  },
]

export default headers